<template>
  <section>
    <Feature v-if="isMutiple" :title="$t('GROUP_KEY')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('TOTAL') + ': ' + quotationList.length]" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Select class="Select" slot="a" v-model="formNo" @on-change="changeFormNo" style="width: 200px">
          <Option v-for="(item, index) in quotationList" :value="item.formNo" :key="index">{{ item.formNo }}</Option>
        </Select>
      </FormRowTwo>
    </Feature>
    <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('FORM_NO') + ': ', $t('RFQ_TYPE') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT_CODE') + ': ', $t('VENDOR_PN') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.formNo" slot="a" disabled />
        <Input class="Input" v-model="rfqType" slot="b" disabled />
        <Input class="Input" v-model="quotation.vendorCode" slot="c" disabled />
        <Input class="Input" v-model="quotation.plant" slot="d" disabled />
        <Input class="Input" v-model="quotation.vendorPart" slot="e" disabled />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CURRENCY') + ': ', $t('DELTA_PN') + ': ', $t('DESCRIPTION') + ': ', $t('REMARK') + ': ']"
        :fieldWidthArr="[364, 364, 728, 728]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.currency" slot="a" disabled />
        <Input class="Input" v-model="quotation.deltaPart" slot="b" disabled />
        <Input style="width: 612px" v-model="quotation.deltaPartDesc" type="textarea" slot="c" disabled :rows="1" />
        <Input style="width: 612px" v-model="quotation.ymgrRemark" type="textarea" slot="d" disabled :rows="1" />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CATEGORY') + ': ']" :fieldWidthArr="[362]" :fieldSpanWidthArr="[100]">
        <Input class="Input" value="Plastic Case" slot="a" disabled />
      </FormRowTwo>
      <FormRowTwo v-if="quotationDocumentView" :fieldNameArr="[$t('PART_SPECIFICATION') + ': ']">
      </FormRowTwo>
      <PLMDocument v-if="quotationDocumentView" :plmQuotationDocuments="plmQuotationDocuments"
        :quotationUuid="quotation.uuid"></PLMDocument>
    </Feature>

    <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('DELTA_BUYER_NAME') + ': ', $t('TARGET_PRICE') + ': ', $t('EMAIL') + ': ']"
        :fieldWidthArr="[364, 364, 728]" :fieldSpanWidthArr="[102, 102, 102]">
        <Input class="Input" v-model="cpcAccountName" slot="a" disabled />
        <Input class="Input" v-model="quotation.targetPrice" slot="b" disabled />
        <Input class="Input" style="width: 612px" v-model="quotation.cpcAccountConstactEmail" type="textarea" slot="c"
          disabled :rows="1" />
      </FormRowTwo>

      <FormRowTwo v-show="hasComments" :fieldNameArr="[$t('COMMENTS') + ': ']" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Button class="Input" icon="ios-create" slot="a" @click="openComments">{{ $t('COMMENTS') }}</Button>
      </FormRowTwo>

      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('REFERENCE_FILE')]">
      </FormRowTwo>
      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('')]">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <Card :title="$t('PLASTIC_CASE_ATTRIBUTES')" class="card-info">
        <FormRowTwo
          :fieldNameArr="[$t('LENGTH') + '(mm): ', $t('WIDTH') + '(mm): ', $t('HEIGHT') + '(mm): ', '*' + $t('GROSS_WEIGHT') + '(g): ', $t('MODEL') + ':']"
          :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
          <Input class="Input" v-model="plasticQuotation.length" slot="a" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.width" slot="b" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.height" slot="c" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.weight" slot="d" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
          <Input class="Input" v-model="plasticQuotation.model" slot="e" :disabled="!quotation.editable" />
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="['*' + $t('RESIN_TYPE') + ':', '*' + $t('RESIN_VENDOR') + ':', '*' + $t('RESIN_NO') + ':', '*' + $t('RESIN_DISTRIBUTOR') + ':', '*' + $t('RESIN_COLOR') + ':']"
          :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
          <Select filterable class="Select" v-if="quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" v-model="resinType"
            @on-change="changeResinType($event)" :placeholder="$t('CHOOSE')" slot="a">
            <Option v-for="(item) in resinTypes" :value="item.type" :key="item.type">
              {{ item.type }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="plasticQuotation.resinType.type" slot="a"
            :disabled="true" />

          <Select filterable class="Select" v-if="quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" v-model="resinVendor"
            @on-change="changeResinVendor($event)" :placeholder="$t('CHOOSE')" slot="b">
            <Option v-for="(item) in resinVendors" :value="item.vendorName" :key="item.vendorName">
              {{ item.vendorName }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="plasticQuotation.resinVendor.vendorName" slot="b"
            :disabled="true" />

          <Select filterable class="Select" v-if="quotation.editable"
            style=" border-color:red;border-width:1px;border-style:solid;" v-model="resinNo"
            @on-change="changeResinNo($event)" :placeholder="$t('CHOOSE')" slot="c">
            <Option v-for="(item) in resinNos" :value="item.partNoDesc" :key="item.partNoDesc">
              {{ item.partNoDesc }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="plasticQuotation.resinNo.partNoDesc" slot="c"
            :disabled="true" />

          <Select filterable class="Select" v-if="quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" v-model="distributor"
            @on-change="changeDistributor($event)" :placeholder="$t('CHOOSE')" slot="d">
            <Option v-for="(item) in distributors" :value="item.vendorName" :key="item.vendorName">
              {{ item.vendorName }}
            </Option>
          </Select>
          <Input class="Input" v-if="!quotation.editable" v-model="plasticQuotation.distributor.vendorName" slot="d"
            :disabled="true" />
          <Input class="Input" v-model="plasticQuotation.resinColor" slot="e" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
        </FormRowTwo>
        <FormRowTwo
          :fieldNameArr="[$t('COLOR_NO') + ':', '*' + $t('RM_PRICE') + '(KG): ', '*' + $t('RM_PRICE_DATE') + ':', $t('DYE_CSOT') + ':', $t('CAVITY_NUMBER') + ':']"
          :fieldWidthArr="[364, 364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102, 102]">
          <Input class="Input" v-model="plasticQuotation.colorNo" slot="a" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.rmPrice" slot="b" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
          <DatePicker class="Input" v-model="plasticQuotation.rmPriceDate" type="date" format="yyyy-MM-dd"
            :placeholder="$t('RM_PRICE_DATE')" slot="c" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;"></DatePicker>
          <Input class="Input" v-model="plasticQuotation.dyeCost" slot="d" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.cavity" slot="e" :disabled="!quotation.editable" />
        </FormRowTwo>
        <FormRowTwo :fieldNameArr="[$t('MACHINE_TONNAGE') + ':', $t('HOURLY_RATE') + ':', $t('CYCLE_TIME')]"
          :fieldWidthArr="[364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102]">
          <Input class="Input" v-model="plasticQuotation.tonnage" slot="a" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.hourlyRate" slot="b" :disabled="!quotation.editable" />
          <Input class="Input" v-model="plasticQuotation.cycleTime" slot="c" :disabled="!quotation.editable" />
        </FormRowTwo>
        <FormRowTwo v-if="showStepTwo" :fieldNameArr="[$t('')]">
          <Table width="600" border :columns="priceColumnList" :data="priceList" slot="a">
          </Table>
        </FormRowTwo>

        <FormRowTwo :fieldNameArr="['*' + $t('YOUR_PRICE'), '/1 ' + quotation.unit]" :fieldWidthArr="[362]"
          :fieldSpanWidthArr="[100]">
          <Input class="Input" v-model="price" slot="a" :disabled="true" ref="yourPrice"
            style="border-color:red;border-width:1px;border-style:solid;" />
        </FormRowTwo>
      </Card>
      <FormRowTwo v-if="quotation.editable"
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]"
        :fieldWidthArr="[554, 554]" :fieldSpanWidthArr="[292, 292]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button class="Input" icon="ios-cloud-upload" style="border-color:red;border-width:1px;border-style:solid;">{{
            $t('UPLOAD') }}</Button>
        </Upload>
        <Button class="Input" type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD')
        }}</Button>
      </FormRowTwo>
      <FormRowTwo v-if="supplierAttachmentExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
            <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
              @click="deleteDocument(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('SUPPLIER_REMARK') + ': ']">
        <Input style="width: 800px" :maxlength="500" type="textarea" :rows="3" v-model="plasticQuotation.supplierRemark"
          slot="a"></Input>
      </FormRowTwo>
    </Feature>

    <ButtonRow>
      <Button v-if="quotation.editable" type="primary" @click="Save" slot="0">{{ $t('SAVE') }}</Button>
      <Button v-if="quotation.editable" type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button v-if="isMutiple && quotation.editable" type="primary" @click="Upload" slot="2">{{ $t('UPLOAD') }}</Button>
      <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
      :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="1300" sticky :draggable="true" v-model="errorMsgModal"
      :title="$t('QUOTATION')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="errorMsgColumnList" :data="errorMessages" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" width="900" sticky :draggable="true" v-model="uploadModel"
      :title="$t('UPLOAD')">
      <FormRow :fieldNameArr="['STEP1']">
        <Button icon="md-cloud-download" type="success" slot="a" @click="downloadSample">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <I style="color: red">Please use excel file, and the first row is column description which will not upload to
        system. Please input your data from second row.</I>
      <FormRow
        :fieldNameArr="['(STEP2) Quotation File sUpload (File Size < 5MB)', batchAttachmentFile == null ? '' : batchAttachmentFile.name]">
        <Upload slot="a" :before-upload="handleBatchAttachmentUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchAttachmentFile !== null" slot="b" @click="uploadBatchAttachement">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="batchAttachmentUuid" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="batchAttachmentFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
      <FormRow :fieldNameArr="['Batch Excel File Upload', batchFile == null ? '' : batchFile.name]">
        <Upload slot="a" :before-upload="handleBatchUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="batchFile !== null" slot="b" @click="uploadBatch">{{ $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
    </Modal>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { CheckFloat } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import PLMDocument from '../../components/PLMDocument.vue'
import { FloraEditorConfig, Translate } from "@/util/common"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "SupplierPlasticMatintain",
  props: {
  },
  components: {
    PLMDocument,
    FormRowTwo
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      priceList: [],
      priceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let html = "<lable>" + this.$t(params.row.key) + "</lable>"
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          render: (h, params) => {
            let styleInfo = {
              'border-width': '1px',
              'border-style': 'solid'
            }
            if (this.priceList[params.index].key == "RM_COST" || this.priceList[params.index].key == "PROCESSING_COST" ||
              this.priceList[params.index].key == "INJECTION_COST" || this.priceList[params.index].key == "ACCESSORIES") {
              styleInfo['border-color'] = 'red'
            }

            if (this.priceList[params.index].key == "TOTAL_COST" || this.priceList[params.index].key == "RM_RATIO_NO_ACCESSORY") {
              return h("div", {
                domProps: {
                  innerHTML: "<lable>" + this.priceList[params.index].value + "</lable>"
                }
              });
            } else {
              return h('Input', {
                props: {
                  type: 'text',
                  value: this.priceList[params.index].value,
                },
                style: styleInfo,
                on: {
                  'on-change': (event) => {
                    if (event.target.value == '' || CheckFloat(event.target.value)) {
                      this.priceList[params.index].value = event.target.value == '' ? 0 : Number(event.target.value)
                      let sum = Number(0)
                      this.priceList.forEach(price => {
                        if (price.value && (price.key == "RM_COST" || price.key == "PROCESSING_COST" || price.key == "INJECTION_COST"
                          || price.key == "ACCESSORIES" || price.key == "OTHERS_PROCESS")) {
                          // sum = math.add(sum, price.value)
                          sum = sum + price.value
                        }
                      })
                      this.price = sum.toFixed(3);
                      let rmCost = Number(0)
                      let accessories = Number(0)
                      this.priceList.forEach(price => {
                        if (price.key == "TOTAL_COST") {
                          price.value = sum.toFixed(3);
                        } else if (price.key == "RM_COST") {
                          rmCost = price.value
                        } else if (price.key == "ACCESSORIES") {
                          accessories = price.value
                        } else if (price.key == "RM_RATIO_NO_ACCESSORY") {
                          price.value = Math.floor((rmCost / (sum.toFixed(3) - accessories) * 100) * 10) / 10
                        }
                      })
                    } else {
                      AlertInfo(this, this.$t('PRICE_MUST_BE_NUMBER')).then(() => {
                      })
                    }
                  }
                }
              })
            }
          },
          align: 'center',
          width: 200,
        }
      ],
      comments: '',
      uuid: '',
      formNo: '',
      quotation: {},
      price: '',
      file: null,
      batchAttachmentFile: null,
      batchFile: null,
      supplierQuotationFiles: [],
      showSupplierQuotationFiles: [],
      plmQuotationDocuments: [],
      cpcToVendorAttachments: [],
      loadingStatus: false,
      commentsModal: false,
      uploadModel: false,
      errorMsgModal: false,
      errorMessages: [],
      batchAttachmentUuid: "",
      batchAttachmentFiles: [],
      resinType: '',
      resinTypes: [],
      resinVendor: '',
      resinVendors: [],
      resinNo: '',
      resinNos: [],
      distributor: '',
      distributors: [],
      resinColor: '',
      resinColors: [],
      plasticQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        model: '',
        resinType: {
          type: ''
        },
        resinVendor: {
          vendorCode: ''
        },
        resinNo: {
          partNo: '',
          partNoDesc: ''
        },
        distributor: {
          vendorCode: ''
        },
        resinColor: '',
        colorNo: '',
        rmPrice: '',
        rmPriceDate: '',
        dyeCost: '',
        cavity: '',
        tannage: '',
        hourlyRate: '',
        cycleTime: '',
        rmCost: '',
        injectingCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      documentColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FILE_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'fileName',
          align: 'center',
          width: 200,
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLM_FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 120,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-download",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.downloadDocument(params.row)
                },
              },
            })
          }
        },
      ],
      scalePriceList: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE'); + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scaleQuantity
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scaleQuantity = event.target.value
                }
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePriceList[params.index].scalePrice
              },
              on: {
                'on-change': (event) => {
                  this.scalePriceList[params.index].scalePrice = event.target.value
                }
              }
            })
          }
        }
      ],
      fileSchemaList: FileSchemaList(this),
      errorMsgColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FORM_NO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Form No",
          width: 100,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('YOUR_PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "Your Price",
          width: 60,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ERROR_MESSAGE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "errorMessage",
          render: (h, params) => {
            let html = "<lable>" + params.row.errorMessage + "</lable>";
            return h("div", {
              domProps: {
                innerHTML: html
              }
            });
          },
          width: 400,
          align: "center",
        },
      ],
    }
  },
  created() {
    const vueInstance = this
    vueInstance.$getRmType(vueInstance, true).then(data => {
      vueInstance.resinTypes = data
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })

    vueInstance.$getReferenceData(vueInstance, "/resin-reference-price/find/vendor").then(data => {
      vueInstance.resinVendors = data
    }).catch((error) => {
      AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
      })
    })

    vueInstance.toggleLoading(true)
    if (vueInstance.getSupplierQuotationId()) {
      vueInstance.uuid = vueInstance.getSupplierQuotationId()
      vueInstance.formNo = vueInstance.getSupplierFormNo()
      vueInstance.$searchSupplierPlastic(vueInstance, false).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else if (vueInstance.getQuotationList().length > 0) {
      vueInstance.formNo = vueInstance.getQuotationList()[0].formNo
      vueInstance.uuid = vueInstance.getQuotationList()[0].uuid
      vueInstance.$searchSupplierPlastic(vueInstance, false).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else {
      vueInstance.toggleLoading(false)
      vueInstance.Back()
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getQuotationList", "getSupplierQuotationId", "getModalSize", "getSupplierFormNo"]),
    ...mapActions(["toggleLoading"]),
    changeResinType(value) {
      const vueInstance = this
      vueInstance.plasticQuotation.resinType = vueInstance.resinTypes.find(function (resinType) {
        return resinType.type == value
      });
    },
    changeResinVendor(value) {
      const vueInstance = this
      vueInstance.plasticQuotation.resinVendor = vueInstance.resinVendors.find(function (resinVendor) {
        return resinVendor.vendorName == value
      });
      vueInstance.toggleLoading(true)
      vueInstance.$getReferenceData(vueInstance, "/resin-reference-price/find/resinNo/" + vueInstance.plasticQuotation.resinVendor.uuid).then(data => {
        vueInstance.toggleLoading(false)
        vueInstance.resinNos = data.sort(function (a, b) {
          return a.partNoDesc.localeCompare(b.partNoDesc, "en");
        });
        vueInstance.plasticQuotation.resinNo = vueInstance.resinNos[0]
        vueInstance.resinNo = vueInstance.resinNos[0].partNoDesc
      })

      vueInstance.$getDistributorByVendor(vueInstance, "RESIN", vueInstance.plasticQuotation.resinVendor.vendorCode).then(data => {
        vueInstance.distributors = data
        if (vueInstance.distributors && vueInstance.distributors.length > 0) {
          vueInstance.plasticQuotation.distributor = vueInstance.distributors[0]
          vueInstance.distributor = vueInstance.distributors[0].vendorName
        } else {
          vueInstance.plasticQuotation.distributor = {
            vendorCode: ''
          }
          vueInstance.distributor = ''
        }
      })
    },
    changeResinNo(value) {
      const vueInstance = this
      vueInstance.plasticQuotation.resinNo = vueInstance.resinNos.find(function (resinNo) {
        return resinNo.partNoDesc == value
      });
    },
    changeDistributor(value) {
      const vueInstance = this
      vueInstance.plasticQuotation.distributor = vueInstance.distributors.find(function (distributor) {
        return distributor.vendorName == value
      });
    },
    Upload() {
      this.uploadModel = true
    },
    downloadSample() {
      let formNos = []
      this.quotationList.forEach(q => {
        formNos.push(q.formNo)
      })
      this.$downloadExcel(this, "supplier/plastic/batch", JSON.stringify(formNos), "")
    },
    handleBatchAttachmentUpload(file) {
      this.batchAttachmentFile = file;
      return false;
    },
    uploadBatchAttachement() {
      let fd = new FormData()
      fd.append('file', this.batchAttachmentFile)
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation", fd)
        .then((response) => {
          this.batchAttachmentFiles = []
          this.batchAttachmentFiles.push(response.data)
          this.batchAttachmentUuid = response.data.uuid
          this.batchAttachmentFile = null
          this.toggleLoading(false)
        })
        .catch(() => {
          this.toggleLoading(false)
        })
    },
    handleBatchUpload(file) {
      this.batchFile = file;
      return false;
    },
    uploadBatch() {
      const vueInstance = this
      let fd = new FormData()
      fd.append('file', this.batchFile)
      let formNos = []
      vueInstance.quotationList.forEach(q => {
        formNos.push(q.formNo)
      })
      fd.append('formNoList', formNos)
      fd.append('fileUuid', vueInstance.batchAttachmentUuid)
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/supplier/plastic/batch-upload", fd)
        .then((response) => {
          vueInstance.toggleLoading(false)
          vueInstance.batchFile = null
          vueInstance.uploadModel = false
          vueInstance.$Swal.fire({
            icon: "info",
            title: Translate("COMMON_MESSAGE_SUCCESS"),
            text: response.data.content[0].status,
          })
          vueInstance.Back()
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          vueInstance.batchFile = null
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            vueInstance.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
        })
    },
    changeFormNo(formNo) {
      const vueInstance = this
      let temp = this.getQuotationList().find(quotation => quotation.formNo == formNo)
      vueInstance.formNo = temp.formNo
      vueInstance.uuid = temp.uuid
      vueInstance.toggleLoading(true)
      vueInstance.$searchSupplierPlastic(vueInstance, false).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    },
    openComments() {
      this.commentsModal = true
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    deleteDocument(row) {
      this.supplierQuotationFiles.forEach(attachment => {
        if (attachment.id == row.id) {
          attachment.deleted = true
        }
      })
      this.showSupplierQuotationFiles = this.supplierQuotationFiles.filter(attachment => !attachment.deleted)
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      if (this.showSupplierQuotationFiles.length < 1) {
        let fd = new FormData()
        fd.append('file', this.file)
        fd.append('description', "quotaion attachement")
        this.toggleLoading(true)
        this.$fileHttp
          .post("/attachment/upload-single?description=quotation" + this.quotation.uuid, fd)
          .then((response) => {
            this.supplierQuotationFiles.push(response.data)
            this.showSupplierQuotationFiles.push(response.data)
            this.file = null
            this.toggleLoading(false)
          })
          .catch(() => {
            this.toggleLoading(false)
          })
      } else {
        let text = "Could not upload more than one quotation file."
        this.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    },
    Save() {
      const vueInstance = this
      let data = buildCriteria(vueInstance)
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.price, vueInstance.quotation.currency, vueInstance.plasticQuotation)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/update", JSON.stringify(data))
          .then((response) => {
            vueInstance.toggleLoading(false)
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Submit() {
      const vueInstance = this
      let data = buildCriteria(vueInstance)
      let errorMessage = vueInstance.valid(vueInstance.quotation.formNo, vueInstance.price, vueInstance.quotation.currency, vueInstance.plasticQuotation)
        + vueInstance.$validSupplierAttachments(vueInstance, vueInstance.showSupplierQuotationFiles.length)
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      } else {
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/submit", JSON.stringify(data))
          .then((response) => {
            if (vueInstance.getSupplierQuotationId()) {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            } else if (vueInstance.getQuotationList().length > 0) {
              vueInstance.$searchSupplierPlastic(vueInstance, false).then(vueInstance => {
                vueInstance.toggleLoading(false)
              })
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            }
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    Back() {
      this.$router.push({ name: 'SUPPLIER_MAINTAIN' })
    },
    valid(formNo, price, currency, plasticQuotation) {
      let errorMessage = this.$validSupplierQuotationPrice(this, "FormNo(" + formNo + ") -", price, currency)

      errorMessage = validTemplate(this, errorMessage, plasticQuotation.length, false, formNo, this.$t('LENGTH'), 1, this.$t('IS_MORE_THAN_ONE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.width, false, formNo, this.$t('WIDTH'), 1, this.$t('IS_MORE_THAN_ONE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.height, false, formNo, this.$t('HEIGHT'), 1, this.$t('IS_MORE_THAN_ONE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.weight, true, formNo, this.$t('GROSS_WEIGHT'), 5, this.$t('IS_MORE_THAN_FIVE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.rmPrice, true, formNo, this.$t('RM_PRICE'), 5, this.$t('IS_MORE_THAN_FIVE_DIGITS'), false);

      if (!plasticQuotation.rmPriceDate) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RM_PRICE_DATE') + " <br>"
      }
      if (!plasticQuotation.resinColor) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RESIN_COLOR') + " <br>"
      }
      if (!plasticQuotation.resinType.type) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RESIN_TYPE') + " <br>"
      }
      if (!plasticQuotation.resinVendor.vendorCode) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RESIN_VENDOR') + " <br>"
      }
      if (!plasticQuotation.resinNo.partNo) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('RESIN_NO') + " <br>"
      }
      if (!plasticQuotation.distributor.vendorCode) {
        errorMessage = errorMessage + "FormNo(" + formNo + ") -" + this.$t('PLEASE_KEY_IN') + this.$t('DISTRIBUTOR') + " <br>"
      }

      errorMessage = validTemplate(this, errorMessage, plasticQuotation.rmCost, true, formNo, this.$t('RM_COST'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.injectionCost, true, formNo, this.$t('INJECTION_COST'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.processingCost, true, formNo, this.$t('PROCESSING_COST'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), false);
      errorMessage = validTemplate(this, errorMessage, plasticQuotation.accessoriesCost, true, formNo, this.$t('ACCESSORIES'), 3, this.$t('IS_MORE_THAN_THREE_DIGITS'), true);
      return errorMessage
    }
  },
  computed: {
    quotationList() {
      return this.getQuotationList()
    },
    isMutiple() {
      return this.getQuotationList() && this.getQuotationList().length > 0
    },
    supplierAttachmentExited() {
      return this.showSupplierQuotationFiles && this.showSupplierQuotationFiles.length > 0
    },
    quotationDocumentView() {
      return this.plmQuotationDocuments && this.plmQuotationDocuments.length > 0
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments && this.cpcToVendorAttachments.length > 0
    },
    rfqType() {
      if (this.quotation.rfqType) {
        return this.quotation.rfqType.description
      } else {
        ""
      }
    },
    cpcAccountName() {
      return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
    },
    hasComments() {
      return this.comments != ""
    },
    modalSize() {
      return this.getModalSize()
    },
    showStepTwo() {
      return this.plasticQuotation.weight && this.resinType && this.resinVendor && this.resinNo && this.distributor && this.plasticQuotation.resinColor
        && this.plasticQuotation.rmPrice && this.plasticQuotation.rmPriceDate
    }
  }
}

function validTemplate(vueInstance, errorMessage, key, isRequire, formNo, keyName, digitsNumber, digitsName, canZero) {
  if (key === undefined || key === "") {
    if (isRequire === true) {
      errorMessage = errorMessage + "FormNo(" + formNo + ") -" + vueInstance.$t('PLEASE_KEY_IN') + keyName + " <br>";
    }
    return errorMessage;
  }
  if (CheckFloat(key) === false) {
    return errorMessage + "FormNo(" + formNo + ") -" + keyName + vueInstance.$t('MUST_BE_NUMBER') + " <br>";
  }
  if (Number(key) < 0 || (Number(key) === 0 && canZero === false)) {
    return errorMessage + "FormNo(" + formNo + ") -" + keyName + vueInstance.$t('MUST_MORE_THAN_ZERO') + " <br>";
  }
  if (Number(key.toString().split("").reverse().join("").indexOf(".")) > Number(digitsNumber)) {
    return errorMessage + "FormNo(" + formNo + ") -" + keyName + digitsName + " <br>";
  }
  return errorMessage;
}

function buildCriteria(vueInstance) {
  vueInstance.priceList.forEach(price => {
    if (price.key == "RM_COST") {
      vueInstance.plasticQuotation.rmCost = price.value
    } else if (price.key == "INJECTION_COST") {
      vueInstance.plasticQuotation.injectionCost = price.value
    } else if (price.key == "PROCESSING_COST") {
      vueInstance.plasticQuotation.processingCost = price.value
    } else if (price.key == "ACCESSORIES") {
      vueInstance.plasticQuotation.accessoriesCost = price.value
    } else if (price.key == "OTHERS_PROCESS") {
      vueInstance.plasticQuotation.others = price.value
    }
  })

  return {
    'currency': vueInstance.quotation.currency,
    'price': vueInstance.price,
    'supplierQuotationFiles': vueInstance.supplierQuotationFiles,
    'uuid': vueInstance.quotation.uuid,
    'category': 'PLASTIC',
    'plasticQuotationDto': {
      'model': vueInstance.plasticQuotation.model,
      'length': vueInstance.plasticQuotation.length,
      'width': vueInstance.plasticQuotation.width,
      'height': vueInstance.plasticQuotation.height,
      'weight': vueInstance.plasticQuotation.weight,
      'resinTypeId': vueInstance.plasticQuotation.resinType.uuid,
      'resinVendorId': vueInstance.plasticQuotation.resinVendor.uuid,
      'resinNoId': vueInstance.plasticQuotation.resinNo.uuid,
      'distributorId': vueInstance.plasticQuotation.distributor.uuid,
      'resinColor': vueInstance.plasticQuotation.resinColor,
      'colorNo': vueInstance.plasticQuotation.colorNo,
      'rmPrice': vueInstance.plasticQuotation.rmPrice,
      'rmPriceDate': vueInstance.plasticQuotation.rmPriceDate,
      'dyeCost': vueInstance.plasticQuotation.dyeCost,
      'cavity': vueInstance.plasticQuotation.cavity,
      'tonnage': vueInstance.plasticQuotation.tonnage,
      'hourlyRate': vueInstance.plasticQuotation.hourlyRate,
      'cycleTime': vueInstance.plasticQuotation.cycleTime,
      'rmCost': vueInstance.plasticQuotation.rmCost,
      'injectionCost': vueInstance.plasticQuotation.injectionCost,
      'processingCost': vueInstance.plasticQuotation.processingCost,
      'accessoriesCost': vueInstance.plasticQuotation.accessoriesCost,
      'others': vueInstance.plasticQuotation.others,
      'supplierRemark': vueInstance.plasticQuotation.supplierRemark,
    }
  }
}
</script>
  
<style scoped></style>
  